import Vue from 'vue'
import moment from 'moment'

Vue.mixin({
  methods: {
    convertToUtcTime(dateString, dateFormat) {
      var inputDate = moment(dateString, dateFormat)
      var outputUtc = moment(inputDate).utc().format(dateFormat)

      return outputUtc
    },
    getLastDayOfMonth(yearMonth) {
      var firstDay = new Date(yearMonth.toString().substr(0, 4), (parseInt(yearMonth.toString().substr(4, 2)) - 1).toString(), '01')
      var y = firstDay.getFullYear()
      var m = firstDay.getMonth()

      return new Date(y, m + 1, 0)
    }
  }
})



// WEBPACK FOOTER //
// ./src/mixins/dateTimeMixin.js